export default __webpack_public_path__ + "static/media/gallery_06.94bac0fd.jpg";